// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"2a5a7274","295":"bd0a12e0","349":"a29d4d7c","453":"d943352b","517":"1c37e2cb","524":"de2aafca","655":"4f72f6e3","667":"81bc8bed","672":"7906b279","783":"dc479ed6","813":"2e1bacf6","910":"7443ba9c","963":"85b30137"}[chunkId] + ".chunk.js";
};